import React from "react";
import { TenantTag } from "./TenantTag";

interface PageTitleProps {
  title: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "103px",
        padding: "0px 32px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        borderRadius: "8px",
        border: "1px solid #F0F0F0",
        background: "#FFF",
        marginBottom: "24px",
      }}
    >
      <h1
        style={{
          margin: 0,
          color: "rgba(0, 0, 0, 0.88)",
          fontFamily: '"Source Sans 3"',
          fontSize: "38px",
          fontStyle: "normal",
          fontWeight: 600,
        }}
      >
        {title}
      </h1>
      <TenantTag />
    </div>
  );
};
